<template>
  <div class="container">
    
      <div class="main" v-for="(item,index) in list" :key="index" @click="linkto(item.m_id)">
        <div class="left" v-if="index == 0">
          <img src="static/img/first.png" class="pride" alt="">
        </div>
        <div class="left" v-else-if="index == 1">
          <img src="static/img/second.png" class="pride" alt="">
        </div>
        <div class="left" v-else-if="index == 2">
          <img src="static/img/third.png" class="pride" alt="">
        </div>
        <div v-else class="left">
          <p>{{index+1}}</p>
        </div>
        <img :src="item.img" class="tx" alt="">
        <p>{{item.name}}</p>
        <p class="jifen">{{item.hours}}h</p>
      </div>
    
  </div>
</template>
<script>
export default {
  name:'jfrank',
  data() {
    return{
      list:[],
      listloading:false,
      listfinished:false,
      listpage:1,
    }
  },
  created(){
    let type;
    if(this.$route.query.type == 'rank_m'){
      type = 'rank_m_all';
    }else if(this.$route.query.type == 'rank_m_org'){
      type = 'rank_m_org';
    }else if(this.$route.query.type == 'rank_y'){
      type = 'rank_y_all';
    }else{
      type = 'rank_y_org';
    }
    this.$axios({
      method:'post',
      url:'/api/home/'+type,
    }).then(res => {
      console.log(res.data);
      this.list = res.data.data;
    })
  },
  methods:{
    linkto(id){
      this.$router.push({
        name:'homepage',
        query:{
          id:id,
        }
      })
    }
  }
}
</script>
<style scoped>
.main{
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #f2f2f2;
}
.left{
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  margin-right: 10px;
}
.left img{
  max-width: 100%;
  max-height: 100%;
}
.jifen{
  margin-left: auto;
  font-weight: bold;
  color: orange;
}
.tx{
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/jfrank.vue